import CompareColumnNew from './CompareColumnNew';

export default CompareColumnNew;
